import Head from 'next/head';
import Link from 'next/link';

import { AboutGLFHHelpSEO } from '@/utils/constants/MetaData';

const AboutGoldLoanFromHome = () => {
  return (
    <>
      <Head>
        <title>{AboutGLFHHelpSEO.metaTitle}</title>
        <meta name="description" content={AboutGLFHHelpSEO.metaDescription} />
        <meta
          property="og:description"
          content={AboutGLFHHelpSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/help/gold-loans/about-gold-loan-from-home/"
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">Gold Loan Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                About Gold Loan Prime
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <h1 className="loanCard__title text--bold text--black">
              About Gold Loan Prime
            </h1>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                <h2 className="text--black text--semi title">
                  What is a Gold Loan Prime?
                </h2>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Gold Loan Prime is a personalised Gold Loan experience for
                    Muthoot FinCorp Ltd. Customers, where a Dedicated
                    Relationship Manager supports you end-to-end in your loan
                    journey. The Dedicated Relationship Manager visits your home
                    to help you complete your KYC and generate a Provisional
                    Loan Offer. They then guide you to the assigned Muthoot
                    FinCorp Ltd. branch to assist with gold valuation, loan
                    approvals, and disbursal.
                    <br />
                    **Available in selected cities
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  What are the benefits of getting a Gold Loan Prime?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    The benefits of getting a Gold Loan Prime are as follows:
                    <p>
                      • One dedicated Relationship Manager for the entire loan
                      journey
                    </p>
                    <p>
                      • Secure home visit for KYC and provisional loan offer
                    </p>
                    <p>
                      • Clear guidance on loan eligibility and applicable
                      schemes
                    </p>
                    <p>• Priority, queue-free assistance at the branch</p>
                    <p>
                      • Seamless digital approvals on the Muthoot FinCorp ONE
                      app
                    </p>
                    <p>
                      • Faster processing and direct disbursal to your bank
                      account
                    </p>
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <p className="text--black text--semi title">
                  How is a Gold Loan Prime different from a traditional Gold
                  Loan?
                </p>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Unlike a traditional Gold Loan where you manage the process
                    on your own at the branch, Gold Loan Prime provides a
                    Dedicated Relationship Manager who:
                    <p>
                      • Visits your home for KYC and provisional loan generation
                    </p>
                    <p>• Guides you through scheme selection</p>
                    <p>
                      • Meets and assists you at the branch for valuation and
                      approvals
                    </p>
                    This makes the process more convenient, guided, and premium.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFour"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                <p className="text--black text--semi title">
                  What are the different Gold Loan schemes available for Gold
                  Loan Prime?
                </p>
              </div>
              <div
                id="collapseFour"
                className="collapse"
                aria-labelledby="headingFour"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Muthoot FinCorp Ltd. offers a variety of Gold Loan schemes
                    to suit the diverse needs of our customers. At the time of
                    provisional loan generation at your home, you will be
                    presented with multiple Gold Loan scheme options. Your
                    Dedicated Relationship Manager will explain each scheme in
                    detail, helping you choose the one that best suits your
                    financial needs.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFive"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                <p className="text--black text--semi title">
                  Will the same Dedicated Relationship Manager assist me at home
                  and as well as the branch?{' '}
                </p>
              </div>
              <div
                id="collapseFive"
                className="collapse"
                aria-labelledby="headingFive"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Yes. The same Dedicated Relationship Manager who visits your
                    home will meet and assist you again at the assigned Muthoot
                    FinCorp Ltd. branch, ensuring continuity and a seamless
                    experience.
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="setting-faq-card">
              <div
                className="header"
                id="headingSix"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                <p className="text--black text--semi title">
                  What is a holiday period in a Gold Loan Prime?
                </p>
              </div>
              <div
                id="collapseSix"
                className="collapse"
                aria-labelledby="headingSix"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    A holiday period is a period in a loan during which the
                    interest slab remains the same. You can ask about the
                    holiday period in your selected scheme from our Loan
                    Manager, once you make an appointment with us for a Gold
                    Loan from Home.
                  </p>
                </div>
              </div>
            </div> */}
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSeven"
                data-toggle="collapse"
                data-target="#collapseSeven"
                aria-expanded="false"
                aria-controls="collapseSeven"
              >
                <p className="text--black text--semi title">
                  In which cities are Gold Loan Prime available?
                </p>
              </div>
              <div
                id="collapseSeven"
                className="collapse"
                aria-labelledby="headingSeven"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Gold Loan Prime is currently available in the major cities
                    of India. The service will be rolled out in additional
                    cities soon.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingEight"
                data-toggle="collapse"
                data-target="#collapseEight"
                aria-expanded="false"
                aria-controls="collapseEight"
              >
                <p className="text--black text--semi title">
                  What happens during the home visit under Gold Loan Prime?
                </p>
              </div>
              <div
                id="collapseEight"
                className="collapse"
                aria-labelledby="headingEight"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    During the home visit, your Dedicated Relationship Manager
                    will assist you in the:
                    <p>
                      • Completion of your KYC verification
                      <p>• Assist with loan documentation</p>
                      <p>
                        • Assess eligibility on the information shared by you
                      </p>
                      <p>• Generate a provisional loan offer on the spot</p>
                    </p>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default AboutGoldLoanFromHome;
